import { render, staticRenderFns } from "./IndexSimple.vue?vue&type=template&id=1ca8dbcf&scoped=true&"
import script from "./IndexSimple.vue?vue&type=script&lang=js&"
export * from "./IndexSimple.vue?vue&type=script&lang=js&"
import style0 from "./IndexSimple.vue?vue&type=style&index=0&id=1ca8dbcf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca8dbcf",
  null
  
)

export default component.exports